import React from 'react';
import Icon from 'components/AppIcon';
import { cn } from 'utils/cn';

const PageHeader = ({
  title,
  subtitle,
  icon,
  action,
  className,
}) => {
  return (
    <div className={cn('flex flex-col md:flex-row md:items-center md:justify-between gap-3 md:gap-4 mb-6 md:mb-10', className)}>
      <div className="flex items-center gap-3">
        {icon && (
          <div className="flex items-center justify-center w-11 h-11 sm:w-12 sm:h-12 bg-gradient-to-br from-primary/12 to-sky-500/10 rounded-xl shrink-0 shadow-soft-sm">
            <Icon name={icon} size={24} className="text-primary shrink-0" />
          </div>
        )}

        <div>
          <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold leading-tight tracking-tight">
            {title}
          </h1>

          {subtitle && (
            <p className="text-sm sm:text-base text-muted-foreground leading-relaxed mt-1 max-w-prose">
              {subtitle}
            </p>
          )}
        </div>
      </div>

      {action && <div className="w-full sm:w-auto shrink-0 [&>*]:w-full sm:[&>*]:w-auto">{action}</div>}
    </div>
  );
};

export default PageHeader;